import { Container, Typography, Grid, Card, CardContent } from "@mui/material";
import SportsCricketIcon from "@mui/icons-material/SportsCricket";
import SportsBaseballIcon from "@mui/icons-material/SportsBaseball";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

const Features = () => {
  const cardStyle = {
    backgroundColor: "#ffffff",
    borderRadius: 3,
    boxShadow: "0 8px 16px rgba(126, 4, 222, 0.1)",
    transition: "transform 0.3s ease",
    "&:hover": {
      transform: "translateY(-10px)",
      boxShadow: "0 12px 20px rgba(126, 4, 222, 0.2)",
    },
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 5, position: "relative", zIndex: 2 }}>
      <Grid container spacing={4} justifyContent="center">
        {[
          {
            icon: <SportsCricketIcon sx={{ fontSize: 50, color: "#7e04de" }} />,
            title: "Professional Equipments",
            description:
              "State-of-the-art batting lanes with advanced tracking technology.",
          },
          {
            icon: (
              <SportsBaseballIcon sx={{ fontSize: 50, color: "#068cc1" }} />
            ),
            title: "Coaching",
            description:
              "Expert coaches to help you improve your batting techniques.",
          },
          {
            icon: <AccessTimeIcon sx={{ fontSize: 50, color: "#f27143" }} />,
            title: "Flexible Booking",
            description: "Easy online booking with flexible timing options.",
          },
        ].map((feature, index) => (
          <Grid item xs={12} sm={4} key={index}>
            <Card sx={cardStyle}>
              <CardContent sx={{ textAlign: "center", py: 3 }}>
                {feature.icon}
                <Typography
                  variant="h6"
                  sx={{ mt: 2, color: "#3c3759", fontWeight: "bold" }}
                >
                  {feature.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {feature.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default Features;
